<header>
  @if (activeAnnouncements.length > 0) {
    <app-announcement-bar [announcements]="activeAnnouncements"></app-announcement-bar>
  }
</header>
<main role="main" class="flex-grow-1 overflow-hidden">
  <div class="f-row main h-100">
    @if (!(modalIsOpen$ | async)) {
      <button class="open-side-bar" (click)="openSideBar()">
        <app-icon icon="menu" class="menu-icon"></app-icon>
      </button>
    }
    <aside role="complementary" aria-label="Side Bar" class="h-100">
      <div class="side-bar-wrapper h-100" [ngClass]="sideBarState">
        <app-side-bar class="side-bar" (shouldCloseSideBar)="closeSideBar($event)"></app-side-bar>
      </div>
    </aside>
    <section role="region" aria-label="Supervisor Content" class="w-100 overflow-y-auto" cdkScrollable>
      <div class="router">
        @if(this.isConfidentialityNoticeVisible()) {
          <div class="confidentiality-notice flex-sm-row f-col gap-3">
            <div class="f-row align-items-center gap-3">
              <app-icon icon="alert-circle" class="large-icon alert-icon"></app-icon>
              <p class="mb-0">This dashboard contains confidential information intended solely for the student it concerns.
                Unauthorized sharing or disclosure of this information is strictly prohibited.
                For questions or concerns, please contact LU Serve at <a href="mailto:cser@liberty.edu" >cser&#64;liberty.edu</a>.</p>
            </div>
            <button (click)="dismissConfidentialityNotice()" class="dismiss-notice-button small-medium-text">Dismiss</button>
          </div>
        } @else {
          <div class="confidentiality-notice-dismissed">
            <button (click)="showConfidentialityNotice()" class="custom-button-small-secondary">View Confidentiality Notice</button>
          </div>
        }
        <router-outlet></router-outlet>
      </div>
    </section>
  </div>
</main>
